import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { PencilSquare, PersonPlusFill, PlusLg, Share } from 'react-bootstrap-icons'
import { BrowseContext } from '../../../contexts/BrowseContext'
import AvatarStack from './CampaignsBrowseParts/AvatarStack'
import EntityMetadataBox from './CampaignsBrowseParts/EntityMetadataBox'
import UnderlineTabs from './CampaignsBrowseParts/UnderlineTabs'
import { CLIENT_PAGE_GUTTER } from './CampaignsBrowseParts/clientPageLayout'

const CLIENT_TABS = [
  { id: 'summary', label: 'Summary' },
  { id: 'timeline', label: 'Timeline' },
  { id: 'calendar', label: 'Calendar' },
]

export default observer(function ClientCampaignsHeader({ activeTab, onTabChange, onNewCalendarEntry }) {
  const { browseState, selectedClient } = useContext(BrowseContext)

  const primaryContact = selectedClient.client_contacts?.[0]
  const contactCount = selectedClient.client_contacts?.length || 0
  const collaborators = (selectedClient.collaborators || []).map(collaborator => ({
    id: collaborator.value,
    label: collaborator.label,
    avatar: collaborator.avatar,
  }))

  return (
    <header className="w-full shrink-0 bg-rb-grey dark:bg-rb-dark-mode-background">
      <div className={`${CLIENT_PAGE_GUTTER} pt-6 pb-0`}>
        <div className="flex w-full justify-between items-start gap-6">
          <div className="min-w-0 flex-1">
            <h1 className="text-2xl font-bold dark:text-white">{selectedClient.name}</h1>
            <div className="mt-3 flex items-center gap-2">
              <AvatarStack avatars={collaborators} />
              <button
                type="button"
                className="flex h-9 w-9 items-center justify-center rounded-full border-1 border-border-primary bg-white text-rb-green hover:bg-gray-100 dark:border-rb-dark-mode-lighter dark:bg-rb-dark-mode dark:hover:bg-rb-dark-mode-lighter"
                onClick={() => browseState.toggleEditClient()}
                title="Add collaborators"
                aria-label="Add collaborators"
              >
                <PersonPlusFill className="h-4 w-4" />
              </button>
            </div>
          </div>
          <div className="flex shrink-0 flex-col items-end gap-2">
            <button
              type="button"
              className="rounded-md text-left hover:opacity-80"
              onClick={() => browseState.openEditClientContacts()}
              title="View client contacts"
              aria-label="View client contacts"
            >
              <EntityMetadataBox
                avatarUrl={primaryContact?.avatar}
                avatarAlt={primaryContact?.name || primaryContact?.email}
                primaryLabel={contactCount > 1 ? `Contacts (${contactCount})` : 'Contact'}
                primaryValue={primaryContact?.name || primaryContact?.email}
                secondaryLabel="Created"
                secondaryValue={selectedClient.created_at?.split('T')[0]}
              />
            </button>
            <div className="flex h-9 items-center gap-2">
              <button
                type="button"
                className="flex h-full items-center gap-2 rounded-lg border-1 border-border-primary bg-white px-4 text-sm font-semibold text-gray-800 hover:bg-gray-100 dark:border-rb-dark-mode-lighter dark:bg-rb-dark-mode dark:text-white dark:hover:bg-rb-dark-mode-lighter"
                onClick={() => browseState.toggleEditClient()}
              >
                <PencilSquare className="text-rb-green dark:text-rb-green" aria-hidden />
                Edit client
              </button>
              {activeTab === 'summary' && (
                <button
                  type="button"
                  className="flex h-full items-center gap-2 rounded-lg border-1 border-border-primary bg-white px-4 text-sm font-semibold text-gray-800 hover:bg-gray-100 dark:border-rb-dark-mode-lighter dark:bg-rb-dark-mode dark:text-white dark:hover:bg-rb-dark-mode-lighter"
                  onClick={() => browseState.toggleShareClient()}
                >
                  <Share className="text-rb-green dark:text-rb-green" aria-hidden />
                  Share
                </button>
              )}
              {activeTab === 'calendar' && (
                <button
                  type="button"
                  className="flex h-full items-center gap-1.5 rounded-lg bg-rb-green px-4 text-sm font-semibold text-white hover:bg-rb-green/90"
                  onClick={onNewCalendarEntry}
                >
                  <PlusLg aria-hidden />
                  New Entry
                </button>
              )}
            </div>
          </div>
        </div>
        <UnderlineTabs
          tabs={CLIENT_TABS}
          activeTab={activeTab}
          onTabChange={onTabChange}
          className="mt-6 border-b border-rb-widget-border dark:border-rb-dark-mode-lighter"
        />
      </div>
    </header>
  )
})
